import { type MemberExtraFragment } from '@/affiliate-dashboard/graphql';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/base/breadcrumbs';
import { cn } from '@/utils';
import { motion } from 'framer-motion';
import { motionVariants } from './animation';

export function Breadcrumbs({
  breadcrumbs,
  onClick,
}: {
  breadcrumbs: MemberExtraFragment[];
  onClick: (id: number) => void;
}): JSX.Element {
  return (
    <Breadcrumb>
      <BreadcrumbList className="w-fit overflow-hidden rounded-xl bg-[#282C38]/50 px-3 dark:bg-[#282C38] sm:gap-0">
        {breadcrumbs.map((breadcrumb, index) => (
          <motion.div
            initial={motionVariants.appear.initial}
            animate={motionVariants.appear.animate}
            exit={motionVariants.appear.exit}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            className="group flex items-center gap-2 px-1 py-2 text-white dark:text-white"
            key={breadcrumb.id}
          >
            <BreadcrumbItem
              className={cn('underline-offset-3 cursor-pointer underline', {
                'cursor-default no-underline': index === breadcrumbs.length - 1,
              })}
              onClick={() => {
                index !== breadcrumbs.length - 1 && onClick(index);
              }}
            >
              <span>{breadcrumb.email}</span>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="group-last:hidden" />
          </motion.div>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
